<script>
export default {
    name: "RadiologyQueue",

    data() {

        return {
            patients: [],
        };
    },

    mounted() {
        this.$root.loading=true;
        Promise.allSettled([ this.fetchQueue(), ]).then(() => {
            this.$root.loading=false;
            setTimeout(() => {
                window.print();
            }, 250);
        }).catch(() => {});
    },

    methods: {

        fetchQueue() {
            let url = `Inpatient/GetWardRoundPendingRadiology`;

            return this.$http.get(url).then(response => {
                this.patients=response.data;
            }).catch(() => { this.$root.loading=false; });
        },
    }
}
</script>
<template>
    <div class="flex flex-wrap">
        <tail-address-header></tail-address-header>
        <div class="w-full my-3 text-center">
            <h5 class="font-medium text-base uppercase">Pending Inpatient Queue</h5>
        </div>
        <table class="table mt-2">
            <thead class="text-sm">
                <tr class="flex w-full">
                    <th class="p-tiny w-1/6">Patient</th>
                    <th class="p-tiny flex-1">MRN</th>
                    <th class="p-tiny flex-1">DOB</th>
                    <th class="p-tiny flex-1">Date</th>
                    <th class="p-tiny flex-1">Progress</th>
                    <th class="p-tiny flex-1">IP No</th>
                    <th class="p-tiny flex-1">OP No</th>
                    <th class="p-tiny w-1/6">Payment</th>
                    <th class="p-tiny w-1/12">Status</th>
                    <th class="p-tiny flex-1">Bed</th>
                    <th class="p-tiny flex-1">Ward</th>
                    <th class="p-tiny w-1/6">Test</th>
                </tr>
            </thead>
            <tbody class="text-sm font-medium flex flex-col items-center overflow-auto w-full">
                <tr class="flex w-full" 
                    v-for="(pat, idx) in patients" :key="idx">
                    <td class="p-tiny w-1/6">{{ pat.names }}</td>
                    <td class="p-tiny flex-1">{{ pat.patienT_ID }}</td>
                    <td class="p-tiny flex-1">{{ pat.dob | dateFormat }}</td>
                    <td class="p-tiny flex-1">{{ pat.date | dateFormat }}</td>
                    <td class="p-tiny flex-1">{{ pat.progress }}</td>
                    <td class="p-tiny flex-1">{{ pat.ipfileno }}</td>
                    <td class="p-tiny flex-1">{{ pat.opfileno }}</td>
                    <td class="p-tiny w-1/6">{{ pat.pmode }}</td>
                    <td class="p-tiny w-1/12">{{ pat.patientstatus }}</td>
                    <td class="p-tiny flex-1">{{ pat.ward || `-` }}</td>
                    <td class="p-tiny flex-1">{{ pat.bed || `-` }}</td>
                    <td class="p-tiny w-1/6">{{ pat.itemName }}</td>
                </tr>
            </tbody>
        </table>
    </div>    
</template>
